import React, { useState, useContext, useEffect } from 'react';
import { Typography, Button, Container, Box, FormHelperText } from '@mui/material';

import StripeSplitFields from './StripeCCForm';
import SavedCard from './SavedCard';

const PaymentForm = (params: any) => {
  const { paymentMethod, methodUpdated } = params; // Get payment methods from props
  const [showCCForm, setShowCCForm] = useState(false);

  const handleCancel = () => {
    setShowCCForm(false);
  }

  const handleCardUpdated = async () => {
    await methodUpdated()
    setShowCCForm(false);
  }

  return (
    <Container maxWidth="sm">
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 3,
        }}>
        <Typography variant="h6" gutterBottom>
          Update Payment Information
        </Typography>

        <Box sx={{ mt: 3, width: '100%' }}>
          {paymentMethod && !showCCForm ? (
            <>
              <SavedCard card={paymentMethod} />

              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                onClick={() => { setShowCCForm(true)}}
              >
                Change Payment Method
              </Button>
            </>
          ) : (
            <StripeSplitFields card={paymentMethod} cancel={handleCancel} updated={handleCardUpdated} />
          )}          
        </Box>
      </Box>
    </Container>
  );
};

export default PaymentForm;
